import { useCallback } from "react";
import { useSelector } from "react-redux";
import { Identifiable } from "../../../models/Identifiable";
import { Exercise } from "../../../models/Exercise";
import { State } from "../../../store";
import useCustomOffer from "../../CustomOffer/hooks/useCustomOffer";

export interface UseCalendarExerciseChoiceParams {
  getDetailsAboutClickedExercise: (exerciseId: number) => void;
  getTicketsByExercise: (id: Identifiable, exercises: Exercise) => void;
  handleCloseModal?: (boolean: boolean) => void;
  handleWhichClicked: (index: number) => void;
  onTimeSelect?: () => void;
}

export function useCalendarExerciseChoice({
  getDetailsAboutClickedExercise,
  getTicketsByExercise,
  handleCloseModal,
  handleWhichClicked,
  onTimeSelect,
}: UseCalendarExerciseChoiceParams) {
  const { getSaleStepByStepId } = useCustomOffer();
  const foundedSaleStep = getSaleStepByStepId();
  const globalShowTicketsPool = useSelector(
    (state: State) => state.config.configuration.showTicketsPoolForStepByStepSale
  );

  const showTimeOfEntance = foundedSaleStep?.alwaysShowTimeToEntryInCalendarSale;
  const showTicketsPool = foundedSaleStep?.showOtherTicketsPool || globalShowTicketsPool;

  const qntState = useSelector((state: State) => state.basket.calendarSaleQntState);

  const getQntStateCount = useCallback(
    (itemId: string) =>
      qntState
        .filter((qntItem) => qntItem.exerciseIds === itemId)
        .reduce((total, currentItem) => total + currentItem.count, 0),
    [qntState]
  );

  const handleTimeSelection = useCallback(
    (index: number, exerciseId: number, exerciseGroup: Identifiable, exerciseItem: Exercise) => {
      getDetailsAboutClickedExercise(exerciseId);
      getTicketsByExercise(exerciseGroup, exerciseItem);
      handleWhichClicked(index);

      if (onTimeSelect) {
        onTimeSelect();
      }

      if (handleCloseModal) {
        handleCloseModal(false);
      }
    },
    [
      getDetailsAboutClickedExercise,
      getTicketsByExercise,
      handleCloseModal,
      handleWhichClicked,
      onTimeSelect,
    ]
  );

  return {
    showTimeOfEntance,
    showTicketsPool,
    getQntStateCount,
    handleTimeSelection,
  };
}
